<template>
  <div>
    <div class="he800">
        <img class="lbImage" src="@/assets/image/首图.jpg" />
    </div>
    <div>
      <div class="titleBox">
        <span class="title">ABOUT US</span>
        <span class="title1">关于我们</span>
        <span class="line"></span>
      </div>
      <div class="module">
        <div class="box">
          <div class="char">
            <p>
              湖北数据端数据科技有限公司成立于2020年5月，是一家扎根湖北武汉、深耕BIM技术、数字孪生技术、数字智能化领域的高新技术服务企业，以智慧街区数字化场景解决方案服务商、景区智能化全场景解决方案服务商、BIM全过程应用服务商、数字孪生模型服务商为核心定位，专注为智慧街区、文旅景区、政企单体等提供全场景数字化解决方案与全周期技术服务。
            </p>
            <p>
              公司以“数智赋能产业，技术服务实体”为核心发展理念，依托数字孪生、BIM技术等核心能力，融合物联网、AI、大数据等前沿技术，打造了从平台研发、定制开发、部署实施到运营维护的全栈服务能力，为智慧街区、文旅景区打造集智能感知、数据融合、智慧管控、场景服务于一体的数字化运营体系，全方位破解传统场景中信息孤岛、管理低效、体验单一等行业痛点，助力客户实现数字化、智能化、精细化升级。
            </p>
          </div>
        </div>
        <img class="weImg" src="@/assets/images/关于我们.png" />
      </div>
    </div>

    <div class="honorsSection">
      <div class="titleBox">
        <span class="title">QUALIFICATION & HONORS</span>
        <span class="title1">资质荣誉</span>
        <span class="line"></span>
      </div>
      <div class="honorRow">
        <div class="honorItem">
          <img src="@/assets/image/certificate.jpg" alt="高新技术企业证书" />
          <p class="honorCaption">高新技术企业</p>
        </div>
        <div class="honorItem">
          <img src="@/assets/image/软著.jpg" alt="软件著作权登记证书" />
          <p class="honorCaption">软著20余项</p>
        </div>
      </div>
    </div>

    <div class="contact">
      <div class="titleBox">
        <span class="title" style="color: rgba(255, 255, 255, 0.75)"
          >CONTACT US</span
        >
        <span class="title1" style="color: rgba(255, 255, 255, 0.95)"
          >联系我们</span
        >
        <span class="line"></span>
      </div>
      <div class="icons">
        <div class="icon">
          <div>
            <img src="@/assets/images/图标1.png" alt="" />
          </div>
          <p>13098823590</p>
        </div>
        <div class="icon">
          <div>
            <img src="@/assets/images/图标2.png" alt="" />
          </div>
          <p>业务监督电话</p>
          <p>18071708638</p>
        </div>
        <div class="icon">
          <div>
            <img src="@/assets/images/图标3.png" alt="" />
          </div>
          <p>data@yiruibim.com</p>
          <p></p>
        </div>
        <div class="icon">
          <div>
            <img src="@/assets/images/图标4.png" alt="" />
          </div>
          <p>武汉市武昌区</p>
          <p>武汉数创大厦23层</p>
        </div>
      </div>
    </div>

    <div id="localMap"></div>
    <div class="bottom">
      <div class="left">
        <p>企业邮箱：data@yiruibim.com</p>
        <p>联系电话：13098823590</p>
        <p>地 址：湖北省武汉市武昌区武汉数创大厦23层</p>
        <p>Copyright © 2026 湖北毅瑞数据科技有限公司 | 版权所有</p>
        <div class="stl1">
          <p @click="handleOpen('1')">备案号：鄂ICP备20013150号-3</p>
          <div @click="handleOpen('2')" class="stl2">
            <img src="@/assets/images/备案图标.png" alt="" />
            <p>鄂公网安备 42018502005941号</p>
          </div>
        </div>
      
      
      </div>
      <div class="right">
        <p class="p1">快速连接</p>
        <div class="stl1">
          <div class="border1" @click="openWeb('1')">
            <div class="flex1">
              <img
                src="@/assets/images/湖北毅瑞建设工程logo-白底.png"
                alt=""
              />
              <p class="p2">毅建通</p>
            </div>
          </div>

          <div class="border1" @click="openWeb('2')">
            <div class="flex1">
              <img
                src="@/assets/images/湖北毅瑞建设工程logo-白底.png"
                alt=""
              />
              <p class="p2">毅惠通</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dibiao from "@/assets/images/dibiao.png";
import { loadTianditu } from "@/utils/tianditu.js";
import { gcj02ToWgs84 } from "@/utils/coord.js";

// 原高德中心点为 GCJ-02，天地图需 WGS84
const GCJ_LNG = 114.342911;
const GCJ_LAT = 30.591433;

export default {
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    this.map = null;
    this.marker = null;
  },
  methods: {
    async initMap() {
      try {
        const T = await loadTianditu();
        const [lng, lat] = gcj02ToWgs84(GCJ_LNG, GCJ_LAT);
        const lnglat = new T.LngLat(lng, lat);
        this.map = new T.Map("localMap");
        this.map.centerAndZoom(lnglat, 17);
        this.map.enableScrollWheelZoom();
        const icon = new T.Icon({
          iconUrl: Dibiao,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32),
        });
        this.marker = new T.Marker(lnglat, { icon });
        this.map.addOverLay(this.marker);
      } catch (e) {
        console.error(e);
      }
    },
    handleClick(val) {
      if (val == "1") {
        window.open("https://mp.weixin.qq.com/s/imOwoU2iMFqoQMTrDgYf5w");
      } else if (val == "2") {
        window.open("https://mp.weixin.qq.com/s/Hi0hWFmYSd51r-vsZu6TCA");
      } else if (val == "3") {
        window.open("https://mp.weixin.qq.com/s/ub_og6OEql-0cm-m9rh88A");
      } else if (val == "4") {
        window.open("https://mp.weixin.qq.com/s/RS0YMtJusbWEetMDn6yVAw");
      } else if (val == "5") {
        window.open("https://mp.weixin.qq.com/s/CMN24K8HDUiMktaoV1goYg");
      } else if (val == "6") {
        window.open("https://mp.weixin.qq.com/s/j28nlOYz12apkwZG9VjCEA");
      }
    },
    openWeb(val) {
      if (val == "1") {
        window.open("https://yjt-web.yiruibim.com/");
      } else if (val == "2") {
        window.open(
          "https://yht.yiruibim.com/"
        );
      } else if (val == "3") {
        window.open("https://dxhcj-jg-web.yiruibim.com/");
      } else if (val == "4") {
        window.open("http://admin.picc.yiruibim.com/#/login");
      } else if (val == "5") {
        window.open("http://cu-xunjian.yiruibim.com/");
      } else if (val == "6") {
        window.open("https://wmsg.yiruibim.com/#/login");
      }
    },
    openApp(val) {
      if (val == "1") {
        window.open("https://www.pgyer.com/rHmH");
      } else if (val == "2") {
      } else if (val == "3") {
        window.open(
          "https://piccapp.picc.com.cn/download/app/piccapp/install/install.html?cid=b8ac24074aa444aebd7844d4bdd89ce3&aid=9e7922d7d31a4bb29ce461951eaec6b6&marketingid=0201zyxt00000000000587"
        );
      } else if (val == "4") {
        window.open("https://www.pgyer.com/Q80p0O");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lbImage {
  width: 100%;
  height: 800px;
  object-fit: cover;
  object-position: center;
}
.module {
  padding: 60px 200px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .weImg {
    width: 45%;
    object-fit: cover;
  }
}
.product {
  padding: 0 200px 60px 200px;
  box-sizing: border-box;
  background-color: #ececec;
  .module1 {
    margin-top: 60px;
    .p1 {
      color: rgba(0, 0, 0, 0.75);
      padding: 0 50px;
      box-sizing: border-box;
      line-height: 40px;
      text-indent: 40px;
      word-spacing: 10px;
      margin-bottom: 30px;
    }
    .pic {
      display: flex;
      justify-content: space-between;
      div {
        width: 20%;
        margin: 0 10px;
        img {
          width: 100%;
          height: 250px;
          object-fit: cover;
        }
        p {
          text-align: center;
        }
      }
    }
  }
}
.imagesBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 300px;
  img {
    width: 230px;
    height: 100px;
    object-fit: contain;
  }
}
.honorItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  img {
    height: 300px;
    width: auto;
    object-fit: contain;
    max-width: 100%;
    margin: 0;
    display: block;
  }
  .honorCaption {
    margin: 12px 0 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.75);
  }
}
.honorRow {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin: 30px 0 0;
}
.honorsSection {
  background-color: #ececec;
  padding-bottom: 40px;
}

@media (max-width: 768px) {
  .honorRow {
    gap: 20px;
  }

  .honorItem img {
    height: 300px;
    width: auto;
  }
}
.news {
  padding: 0 200px 60px 200px;
  box-sizing: border-box;
  background-color: #fff;
  .firImg {
    width: 290px;
    height: 198px;
    object-fit: fill;
    margin: auto;
  }
  .pic {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      width: 400px;
      height: 225px;
      margin: 40px 10px 0 10px;
      .picImg {
        width: 400px;
        height: 200px;
        border: 1px dotted #d1d0d0;

        img {
          width: 398px;
          height: 198px;
          object-fit: contain;
        }
      }
      p {
        text-align: center;
        color: #807f7f;
      }
    }
  }
}
.contact {
  padding: 0 450px;
  box-sizing: border-box;
  background-color: rgb(97, 150, 187);
  .icons {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 265px;
      height: 176px;
      img {
        width: 175px;
        height: 80px;
        object-fit: contain;
      }
      p {
        font-size: 18px;
        font-weight: 700;
        line-height: 40px;
        color: rgba(255, 255, 255, 0.95);
      }
    }
  }
}
#localMap {
  width: 100%;
  height: 400px;
}
.bottom {
  display: flex;
  align-items: center;
  padding: 30px 100px;
  box-sizing: border-box;
  background-color: rgb(97, 150, 187);
  .left {
    margin-right: 50px;
    .stl1 {
      display: flex;
      align-items: center;
      margin-top: 10px;
      p {
        margin-right: 40px;
        color: rgba(255, 255, 255, 0.65);
        cursor: pointer;
      }
      .stl2 {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    p {
      color: rgba(255, 255, 255, 0.95);
      line-height: 20px;
      font-size: 14px;
    }
  }
  .right {
    .stl1 {
      display: flex;
      align-items: center;
      margin-top: 10px;
    }

    .el-tooltip {
      margin-right: 20px;
      img {
        width: 25px;
        height: 25px;
        margin-right: 10px;
      }
      p {
        color: rgba(255, 255, 255, 0.95);
        font-size: 14px;
      }
    }

    .border1 {
      cursor: pointer;
      margin-right: 20px;
      p {
        color: rgba(255, 255, 255, 0.95);
        font-size: 14px;
      }
      img {
        height: 30px;
        width:30px;
        object-fit: contain;
      margin-right: 5px;

      }
    }
    .border1:last-child {
      margin-right: 0;
    }
  }
}
.sp1 {
  color: #00a2ff;
  font-size: 15px;
  font-weight: 700;
  margin: 20px 10px;
  cursor: pointer;
}
::v-deep .el-carousel__container {
  height: 800px;
}
</style>
